<template>
  <div class="table-wrapper" >
    <p class="table-title "
    v-if="tBodyData.length > 0 || tzjBodyData.length > 0">
      <span>
        <i />
        <span class="hname">{{this.precentName}}</span>
        <span class="hpname">{{this.precent}} </span>
      </span>
      <span class="date-title">{{holddate}}</span>
    </p>
    <div class="cnhwtipbox" v-if="tipshow">
      <div class="cnhwtipinner">
        <img src="@/assets/warn-tip-red.png" class="cnhwtiptip-red" alt />
        <p class="cnhwtiptext">根据交易所监管要求，您所在的地区当前行情延迟15分钟展示。</p>
      </div>
    </div>
    <div class="theadtop" v-if="tBodyData.length > 0 || tzjBodyData.length > 0">
      <div v-for="(hItem,hIndex) in tHeadData" :key="hIndex" class="thead">
        <img src alt v-if="hIndex === 0" />
        <span class="hItem-text">{{hItem}}</span>
      </div>
    </div>

    <div class="tbody" v-if="tBodyData.length > 0 || tzjBodyData.length > 0">
      <div
        v-for="(bItem,bIndex) in tBodyData"
        :key="bIndex"
        class="bItem"
        @click="clickCell(bItem)"
      >
        <div>
          <span class="bItem-name">{{bItem.name}}</span>
          <span class="bItem-tiplist">
            <span class="bItem-marketcode" v-if="bItem.SCTip" >{{bItem.SCTip}}</span>
            <span class="bItem-code" v-if="bItem.INDEXNAME !== '--'" >{{bItem.INDEXNAME}}</span>
          </span>
        </div>
        <div v-if="bItem.saleTip === '停牌'">
          <span class="bItem-proportion">{{bItem.saleTip}}</span>
        </div>
        <div v-else>
          <span :class="['bItem-price', `${upDown(bItem.RZdf)}`]">{{bItem.price}}</span>
          <span :class="['bItem-priceRatio', `${upDown(bItem.RZdf)}`]">{{bItem.priceRatio}}</span>
        </div>
        <div>
          <span class="bItem-proportion">{{bItem.proportion}}</span>
        </div>
        <div>
          <div class="jsq-r">
            <img class="jsq-arrow" v-if="bItem.up === '1'" src="../assets/chicang-up.png" >
            <img class="jsq-arrow" v-if="bItem.up === '2'" src="../assets/chicang-down.png" >
            <span class="bItem-previous">{{bItem.previous}}</span>
          </div>
        </div>
      </div>
      <div v-for="(bItem,bIndex) in tzjBodyData" :key="bIndex" class="bItem">
        <div>
          <span class="bItem-zjname">{{bItem.name}}</span>
        </div>
        <div>
          <span class="bItem-previous">{{bItem.proportion}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JS from '@/base/JSTool';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  name: 'FundTablePositions',
  components: {
  },
  data() {
    return {
      precent: 0,
      precentName: '重仓股票',
      fundCode: '',
      nativeData: {},
      dataCc: {},
      tHeadData: ['股票名称', '价格', '持仓占比', '较上期'],
      tzjBodyData: [],
      gpkhTip: '',
      gpkhLink: {},
      tBodyData: [],
      holddate: '',
      assdate: '',
      tipshow: false,
      // tBodyData: new Array(5).fill({
      //   name: '****',
      //   code: '----',
      //   price: '--',
      //   priceRatio: '--',
      //   proportion: '--',
      //   previous: '--',
      // }),
    };
  },
  mounted() {},
  methods: {
    async render(iscache) {
      this.assdate = StoreManger.getFundJJCCAssetExpansion();
      this.holddate = StoreManger.getFundJJCCExpansion();
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.loadData(iscache);
    },
    async loadData() {
      const basedata = StoreManger.getFundJJCC();
      if (basedata) {
        this.dataCc = basedata.InverstPosition;
        this.holddate = StoreManger.getFundJJCCExpansion();
      }
      if (!this.dataCc) {
        return;
      }
      const datas = this.dataCc.fundStocks;
      const datas2 = this.dataCc.fundboods;
      if (datas && datas2) {
        let gpTo = 0;
        let zjTo = 0;
        for (let i = 0; i < datas.length; i += 1) {
          const data = datas[i];
          const { JZBL } = data;
          if (JZBL !== '--') {
            gpTo = parseFloat(gpTo) + parseFloat(JZBL);
          }
        }
        for (let i = 0; i < datas2.length; i += 1) {
          const data = datas2[i];
          const { ZJZBL } = data;
          if (ZJZBL !== '--') {
            zjTo = parseFloat(zjTo) + parseFloat(ZJZBL);
          }
        }
        if (gpTo > zjTo) {
          // 显示重仓股票
          const tempDatas = [];
          let showTotal = 0;
          for (let i = 0; i < datas.length; i += 1) {
            const data = datas[i];
            const { PCTNVCHGTYPE, JZBL, PCTNVCHG } = data;
            const JZBLper = `${parseFloat(JZBL).toFixed(2)}%`;
            const PCT = JS.fetchNumber(data, 'PCTNVCHG');
            if (PCTNVCHGTYPE === '新增' || PCTNVCHGTYPE === '不变') {
              const item = {
                name: data.GPJC,
                code: data.GPDM,
                INDEXNAME: data.INDEXNAME,
                price: '--',
                priceRatio: '--',
                proportion: JZBLper,
                up: 0,
                previous: `${PCTNVCHGTYPE}`,
                newtexch: data.NEWTEXCH,
              };
              tempDatas.push(item);
            } else if (!PCT) {
              const item = {
                name: data.GPJC,
                code: data.GPDM,
                INDEXNAME: data.INDEXNAME,
                price: '--',
                priceRatio: '--',
                proportion: JZBLper,
                previous: '--',
                up: 0,
                newtexch: data.NEWTEXCH,
              };
              tempDatas.push(item);
            } else if (PCTNVCHG > 0) {
              const item = {
                name: data.GPJC,
                code: data.GPDM,
                INDEXNAME: data.INDEXNAME,
                price: '--',
                priceRatio: '--',
                proportion: JZBLper,
                up: '1',
                previous: `${parseFloat(PCT).toFixed(2)}%`,
                newtexch: data.NEWTEXCH,
              };
              tempDatas.push(item);
            } else {
              const item = {
                name: data.GPJC,
                code: data.GPDM,
                INDEXNAME: data.INDEXNAME,
                price: '--',
                priceRatio: '--',
                proportion: JZBLper,
                up: '2',
                previous: `${parseFloat(0 - PCT).toFixed(2)}%`,
                newtexch: data.NEWTEXCH,
              };
              tempDatas.push(item);
            }
            showTotal = parseFloat(showTotal) + parseFloat(JZBL);
          }
          this.precent = `${showTotal.toFixed(2)}%`;
          if (tempDatas.length > 10) {
            tempDatas.splice(10, tempDatas.length - 10);
          }
          this.tBodyData = tempDatas;
          this.loadPrice(datas);
        } else {
          // 显示重仓债券
          this.tHeadData = ['债券名称', '', '', '持仓占比'];
          const tempDatas = [];
          let showTotal = 0;
          for (let i = 0; i < datas2.length; i += 1) {
            const data = datas2[i];
            const { ZQMC, ZQDM, ZJZBL } = data;
            let ZJZBLper = '--';
            if (ZJZBL !== '--') {
              ZJZBLper = `${parseFloat(ZJZBL).toFixed(2)}%`;
            }
            const item = {
              name: ZQMC,
              ZQDM,
              proportion: ZJZBLper,
            };
            tempDatas.push(item);
            if (ZJZBL !== '--') {
              showTotal = parseFloat(showTotal) + parseFloat(ZJZBL);
            }
          }
          this.precentName = '重仓债券';
          this.tBodyData = [];
          this.precent = `${showTotal.toFixed(2)}%`;
          if (tempDatas.length > 10) {
            tempDatas.splice(10, tempDatas.length - 10);
          }
          this.tzjBodyData = tempDatas;
        }
      } else {
        this.tBodyData = [];
      }
    },
    async loadPrice(fundStocks) {
      if (fundStocks && fundStocks.length > 0) {
        let secids = '';
        for (
          let i = 0;
          i < (fundStocks.length > 10 ? 10 : fundStocks.length);
          i += 1
        ) {
          secids = `${secids + fundStocks[i].NEWTEXCH}.${fundStocks[i].GPDM},`;
        }
        const allinfo = await this.$store.dispatch('updateStokeCodelist', secids);
        if (allinfo.lt === '2' || allinfo.lt === 2) {
          this.tipshow = true;
        } else {
          this.tipshow = false;
        }
        let datas = [];
        if (this.$store.state.emhq.fund[secids].data) {
          datas = this.$store.state.emhq.fund[secids].data.diff;
        }
        const hqDic = {};
        for (let i = 0; i < datas.length; i += 1) {
          const priceData = datas[i];
          hqDic[priceData.f12] = priceData;
        }
        const tempDatas = [];
        for (let i = 0; i < this.tBodyData.length; i += 1) {
          const storeHouseData = this.tBodyData[i];
          let priceStr = '--';
          if (this.checkItemIsV(hqDic[storeHouseData.code], 'f2')) {
            priceStr = `${hqDic[storeHouseData.code].f2.toFixed(2)}`;
          }
          let zdfper = '--';
          let f3 = 0;
          if (this.checkItemIsV(hqDic[storeHouseData.code], 'f3')) {
            zdfper = `${hqDic[storeHouseData.code].f3.toFixed(2)}%`;
            f3 = hqDic[storeHouseData.code].f3;
          }
          const item = {
            name: storeHouseData.name,
            code: storeHouseData.code,
            INDEXNAME: storeHouseData.INDEXNAME,
            price: priceStr,
            RZdf: `${f3}`,
            priceRatio: zdfper,
            proportion: storeHouseData.proportion,
            up: storeHouseData.up,
            previous: storeHouseData.previous,
            newtexch: storeHouseData.newtexch,
          };
          // 直接使用证券@马文豹提供的参数市场号f13，按照数字进行自定义转换，0-深交所，1-上交所，116(128）港交所，105纳斯达克，106纽交所，107美交所。
          // console.log(hqDic[storeHouseData.code]);
          if (hqDic[storeHouseData.code]) {
            if (hqDic[storeHouseData.code].f13 === 116
            || hqDic[storeHouseData.code].f13 === 128) {
              item.SCTip = 'HK';
            }
            if (hqDic[storeHouseData.code].f13 === 105
            || hqDic[storeHouseData.code].f13 === 106
            || hqDic[storeHouseData.code].f13 === 107) {
              item.SCTip = 'US';
            }
          }
          // 停牌  @马文豹f292是6或14的时候是停牌
          if (hqDic[storeHouseData.code]) {
            if (hqDic[storeHouseData.code].f292 === 6
            || hqDic[storeHouseData.code].f292 === 14) {
              item.saleTip = '停牌';
            }
          }
          tempDatas.push(item);
        }
        this.tBodyData.splice(0, this.tBodyData.length);
        this.tBodyData = tempDatas;
      }
    },
    checkItemIsV(item, key) {
      if (!item) {
        return false;
      }
      if (!key) {
        return false;
      }
      if (item[key]) {
        if (item[key] === '-') {
          return false;
        }
        return true;
      }
      if (item[key] === 0) {
        return true;
      }
      return false;
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    clickCell(item) {
      const { code, newtexch } = item;
      const checkString = (string) => string && string !== '-' && string !== '--';
      if (checkString(newtexch)) {
        const type = parseInt(newtexch, 0);
        if (
          type === 0
          || type === 1
          || type === 105
          || type === 106
          || type === 107
          || type === 116
        ) {
          // const domin = fund.getUrlConfigSync({
          //   remoteKey: 'EastVip',
          //   localKey: 'EastVip',
          // });
          // ❌ 缺少此域名配置
          const domin = 'https://vipmoney.eastmoney.com/';
          const linkTo = `${domin}crumbs/ttjjstock/index?id=${code}&mk=${newtexch}`;
          detailPushPage({
            type: 2,
            url: linkTo,
          });
          this.reportMonitor({
            eventName: 'pz.jjcc.pg.click',
            infoCodeType: '5',
            infoCode: this.fundCode,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.table-wrapper {
  padding: 0 0px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.hname {
  font-family: PingFangSC-Regular;
  margin-right: 16px;
}
.table-title {

  padding: 0 24px;
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
  line-height: 84px;
  height: 84px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    width: 10px;
    height: 10px;
    background-color: #F96B36;
    margin-right: 10px;
    display: inline-block;
    border-radius: 50%;
    position: relative;
  }
}
.date-title{
  color: #999999;
  text-align: right;
  align-items: center;
  display: flex;
}
.tbody{
  padding: 0 24px;
}
.theadtop{
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
}
.thead {
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:nth-child(1) {
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      align-items: flex-end;
    }
  }
}

.hItem-text {
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
}

.gpkhtip-text{
  font-family: PingFangSC-Regular;
  font-size: 28px;
  line-height: 38px;
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #83A6CF;
}

.bItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 26px 0;
  line-height: normal;
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    &:nth-child(1) {
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      align-items: flex-end;
    }
  }
  &-name {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000000;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 150px;
  }
  &-zjname{
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-tiplist{
    flex-direction: row;
    margin-top: 10px;
    align-items: flex-start;
    display: flex;
    flex: 1;
  }
  &-marketcode {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #666666;
    line-height: 24px;
    overflow: hidden;
    padding-top: 5px;
    border-radius: 4px;
    margin-right: 6px;
  }
  &-code {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #666666;
    line-height: 24px;
    overflow: hidden;
    background: rgba(102, 102, 102, 0.1);
    padding: 5px;
    border-radius: 4px;
  }
  &-price {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-priceRatio {
    font-family: DINAlternate-Bold;
    font-size: 26px;
    text-align: center;
    line-height: 26px;
    margin-top: 2px;
  }
  &-proportion {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: center;
    line-height: 30px;
  }
  &-previous {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: right;
    line-height: normal;
  }
}
.jsq-r{
  display: flex;
  flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: -6px;
}
.jsq-arrow{
  margin-right: 10px;
  height: 20px;
  width: 12px;
}
.right-arrow {
  margin-left: 5px;
  width: 32px;
  height: 32px;
}
.cnhwtipbox {
  background: #FDF8F0;
}
.cnhwtipinner {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 10px 10px 10px;
}

.cnhwtiptext {
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff4400;
  line-height: 42px;
  padding-left: 10px;
  text-align: left;
}

.cnhwtiptip-red {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  align-self: flex-start;
  padding: 10px 0px;
}
</style>
